import React from "react";
import { FaCrown } from "react-icons/fa";
import Tooltip from "../../../Components/tooltip/tooltip";
import "./top10Item.css";
import useTop10Item from "./use-Top10Item";

const Top10Item = ({ player, index, timeframe }) => {
  // get profile image
  const imgSrc = useTop10Item(player.agentCode, player.agentGender);

  const topClass = index === 0 ? "top1" : index === 1 ? "top2" : index === 2 ? "top3" : "";
  const crownIcon =
    index < 3 ? (
      <FaCrown
        className="crown-icon"
        color={index === 0 ? "#FFD700" : index === 1 ? "#C0C0C0" : "#CD7F32"}
      />
    ) : null;

  const anbp = timeframe === "mtd" ? player.anbp : player.anbp;
  const nop = timeframe === "mtd" ? player.nop : player.nop;
  return (
    <div className={`top10-item animate-item ${topClass}`} style={{ animationDelay: `${index * 0.05}s` }}>
      <span className="rank">{index + 1} {crownIcon}</span>
      <div className="name-with-avatar">
        <img src={imgSrc} alt="User" className={`small-avatar ${index < 3 ? "top-rank" : ""}`} />
        <div className="name-details">
          <span className="agent-code">{player.agentCode}</span>
          <Tooltip text={player.agentName || "N/A"} position="top">
            <span className="name">{player.agentName}</span>
          </Tooltip>
          <span className="branch-name">{player.branchName || "N/A"}</span>
        </div>
      </div>
      <div className="labels-container">
        <div className="label-item">ANBP</div>
        <div className="label-item">NOP</div>
      </div>
      <div className="values-container">
        <span className="anbp">{anbp?.toLocaleString() || 0}</span>
        <span className="nop">{nop || 0}</span>
      </div>
    </div>
  );
};

export default Top10Item;
